export const ADD_MESSAGE = 'message/ADD_MESSAGE';
export const DISMISS_MESSAGE = 'message/DISMISS_MESSAGE';
export const ROUTE_CHANGE = 'message/ROUTE_CHANGE';
